<template>
  <div class="home">
    <heads class="navShow"></heads>

    <div class="swiper-wrapper" v-loading="swiperLoading">
      <swiper
        v-if="bannerArray.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        <swiper-slide
          class="slide-1"
          v-bind:style="{
            backgroundImage: 'url(' +'\'' + getPreUrl + item.path[0] +'\'' + ')'
          }"
          @click.native.stop="handleSlideClick(item.pagetype,item.link)"
          v-for="(item, index) in bannerArray"
          :key="index"
        >
        </swiper-slide>
        <div
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
        <div
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <div class="search-wrapper">
        <div>
          <div class="search-top-wrapper">
            <div class="home-hots">
              <ul>
                <span>热门玩法</span>
                <li v-for="item in popularList" :key="item.id">
                  <div>
                    <p @click="toTeamBuilding(item.id,item.playTypeId)">{{ item.name }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="home-search-bar-content">
            <div
              class="component-select"
              style="width: 200px; height: 100%"
              @click="showSelectContent"
            >
              <div id="component-select-label" class="component-select-label">
                <img
                  src="../assets/svg/home-banner-flag.svg"
                  alt=""
                />团建去哪玩
              </div>
              <div id="component-select-option" class="component-select-option">
                <div class="component-select-option-placeholder">
                  <span></span>
                </div>
                <div class="component-select-option-drop">
                  <!-- <img src="../assets/svg/down-arrow.svg" alt=""  :class="!isSelectContent?'el-icon-caret-bottom':'el-icon-caret-top'"> -->
                  <span
                    class="el-icon"
                    :class="
                      !isSelectContent
                        ? 'el-icon-caret-bottom'
                        : 'el-icon-caret-top'
                    "
                  ></span>
                </div>
                <!---->
              </div>
              <div
                id="component-select-content"
                class="component-select-content"
                style="width: 760px"
                v-if="isSelectContent"
              >
                <div>
                  <div class="component-tabtitle">
                    <div
                      class="component-tabtitle-item"
                      v-for="(item, index) in selectTitle"
                      :key="item.id"
                      v-on:click.stop="selectTitleMethod(index)"
                    >
                      <span
                        class="component-tabtitle-name"
                        style="font-size: 16px; color: #222"
                        >{{ item.name }}</span
                      >
                      <div
                        class="component-tabtitle-border"
                        v-if="selectTitleNum == index"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="
                      component-select-content-items
                      component-select-content-items-fold
                    "
                  >
                    <ul>
                      <li
                        v-for="item in selectContentArray"
                        :key="item.id"
                        class=""
                        @click="selectContentMethod(item.id)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="
                width: 10px;
                border-right: 1px solid #e8e8e8;
                margin-top: 16px;
                margin-bottom: 16px;
              "
            ></div>
            <img
              src="../assets/svg/home-banner-zoom.svg"
              alt=""
              style="margin-left: 20px"
            />
            <input
              type="text"
              placeholder="试试搜索目的地/产品名称"
              v-model="searchVal"
            />
            <div class="home-search-submit" @click="toSearch()">搜索</div>
            <img src="../../static/images/customizedTip.png" class="customized-tip" @click="goToCustomPage"/>
          </div>
          <!-- <div class="search-input-wrapper">
          <input
            type="text"
            class="search-input"
            v-model="searchVal"
            @keyup.enter="toSearch"
            placeholder="请输入您想查找的内容"
          />
          <div class="search-btn" @click="toSearch">
            <span class="el-icon-search"></span>
            搜索
          </div>

        </div> -->
        </div>
      </div>
      <img src="../assets/svg/home-banner-cover.svg" class="banner-cover" />
    </div>
    <div class="second-part-out">
      <div class="second-part">
        <div class="flow">
          <div
            v-for="(item, index) in processArray"
            :key="index"
            class="flow-item"
          >
            <img :src="item.path" alt class="size-change" />
            <!-- <img  src="../assets/svg/home-flow1.svg" alt=""> -->
            <span>{{ item.title }}</span>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--热门团建产品-->
    <hotTeamProduct :message="hotTeamProductMessage" ref="hotTeamProduct" />
    <!--热门团建目的地-->
    <hotTeamGoalPlace
      :message="hotTeamGoalPlaceMessage"
      ref="hotTeamGoalPlace"
    />
    <!--客户服务案例-->
    <customCase :message="customCaseMessage" ref="customCase" />
    <!--横幅-->
    <ourAdvantages :message="ourAdvantagesMessage" ref="ourAdvantages" />
    <!--活动策划-->
    <teamIntroduct ref="teamIntroduct" />
    <homeFoots></homeFoots>
    <homeBottomImage style="z-index:1000"></homeBottomImage>
    <quickContact :message="quickContactMessage"></quickContact>
    <!--活动策划-->
    <coupon style="z-index: 1000;"></coupon>

  </div>
  <!-- home end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import customCase from "@/components/home/customCase.vue";
import hotTeamGoalPlace from "@/components/home/hotTeamGoalPlace.vue";
import hotTeamProduct from "@/components/home/hotTeamProduct.vue";
import ourAdvantages from "@/components/home/ourAdvantages.vue";
import teamIntroduct from "@/components/home/teamIntroduct.vue";
import wxShare from "@/common/wx_share.js";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import axios from "axios";
import coupon from './comment/coupon.vue';
export default {
  name: "home",
  data() {
    return {
      placeholderText: "查立项",
      titleIndex: 0,
      downloadNavArray: [],
      swiperLoading: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        swiperLoading: false,
      },
      swiperOptionThumbs: {
        autoplay: true,
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: "auto",
        centeredSlides: true,
        touchRatio: 0.2,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slideToClickedSlide: true,
      },
      searchVal: "",
      bannerArray: [],
      show: false,
      top: "",
      pageArray: [],
      radio: "1",
      centerDialogVisible: true,

      //模块数据
      generalList: [],
      specialList: "",
      showCard: false,
      // 过程数组
      processArray:[],
      // lxq
      // --- 搜索相关
      playMethod: [
        {
          id: 1,
          name: "水上娱乐",
        },
        {
          id: 2,
          name: "主题创意",
        },
        {
          id: 3,
          name: "趣味拓展",
        },
      ],
      selectTitle: [
        {
          id: 1,
          name: "本市行政区",
          child: [],
        },
        {
          id: 2,
          name: "省内城市",
          child: [],
        },
        {
          id: 3,
          name: "国内城市",
          child: [],
        },
        {
          id: 4,
          name: "国际长线",
          child: [],
        },
      ],
      isSelectContent: false,
      selectTitleNum: 0,
      selectContentArray: [],
      // --- 搜索相关
      // --- banner下方描述
      picPath: [
        require("../assets/svg/home-flow2.svg"),
        require("../assets/svg/home-flow1.svg"),
        require("../assets/svg/home-flow3.svg"),
        require("../assets/svg/home-flow4.svg"),
      ],
      // --- banner下方描述

      // --- 传递给组件的参数
      hotTeamProductMessage: [],
      hotTeamGoalPlaceMessage: [],
      customCaseMessage: [],
      ourAdvantagesMessage: [],

      // --- 传递给组件的参数

      adPositionList: [],
      headBanner: [],

      scenicSpotsList: [],
      // 省内城市
      surroundCityList: [],
      // 国际长线
      foreignCityList: [],
      // 国内城市
      domesticCityList: [],
      
      regionList: [],
      quickContactMessage: {
        type: 1,
      },
      // 玩法
      popularList: [],
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact,
    customCase,
    hotTeamGoalPlace,
    hotTeamProduct,
    ourAdvantages,
    teamIntroduct,
    homeBottomImage,
    coupon
  },
  computed: {
    getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    },
    // 前置图片路径
    getPreUrl() {
      return this.$store.state.picPreUrl;
    },
    // 站点城市
    getSiteCityList() {
      return this.$store.state.siteCityList;
    },
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    // 去定制页面
    goToCustomPage(){
      window.open("/#/custom");
    },
    //处理图片
    handlePic(pictureStr) {
      if (pictureStr) {
        const imageList = pictureStr.split(",");
        let imagePicList = [];
        // 连接API名
        imageList.forEach((item) => {
          imagePicList.push(item);
        });
        return imagePicList;
      }
    },
    setSearch(item, index) {
      this.placeholderText = item;
      this.titleIndex = index;
    },
    enter(index) {
      this.show = true;
    },
    leave() {
      this.show = false;
    },
    toSearch() {
      this.$router.push({
        path: "/teamBuilding",
        query: { search: this.searchVal },
      });
    },
    // 获取热门玩法
    getPopularPlay() {
      axios.get(`/api/tb/popularPlay`, {}).then((res) => {
        if (res.data && res.data.code == 200) {
          this.popularList = res.data.data;
        }
      });
    },
    // 查询行政区
    getRegionList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: cityId,
      };
      axios
        .get(`/api/city/cityRegionList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.regionList = res.data.cityRegionList;
            if (this.regionList) {
              this.regionList.forEach((region) => {
                region.id = region.regionId;
                region.name = region.regionName;
              });
            }
            this.selectTitle[0].child = this.regionList;
            console.log(this.selectTitle[0].child);
          }
        });
    },

    // // 查询景区
    // getScenicSpotsList() {
    //   let cityId = this.getLocationSiteCityId;
    //   let params = {
    //     cityId: cityId,
    //   };
    //   axios
    //     .get(`/api/city/scenicSpotslist`, {
    //       params,
    //     })
    //     .then((res) => {
    //       if (res.status == 200 && res.data.code == 200) {
    //         this.scenicSpotsList = res.data.scenicSpotslist;
    //         this.selectTitle[2].child = this.scenicSpotsList;
    //       }
    //     });
    // },
     // 查询省内城市
    getSurroundCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/surroundCityList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.surroundCityList = res.data.surroundCityList;
            if (this.surroundCityList) {
              this.surroundCityList.forEach((surroundCity) => {
                surroundCity.id = surroundCity.cityId;
                surroundCity.name = surroundCity.cityName;
              });
            }
            console.log();
            this.selectTitle[1].child = this.surroundCityList;
          }
        });
      console.log("this.selectTitle[1].child");
      console.log(this.selectTitle[1].child);
    },
   
    // 查询国内城市
    getDomesticCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
            axios
        .get(`/api/city/domesticCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.domesticCityList = res.data.domesticCityList;
            if (this.domesticCityList) {
              this.domesticCityList.forEach((domesticCity) => {
                domesticCity.id = domesticCity.cityId;
                domesticCity.name = domesticCity.cityName;
              });
            }
            console.log();
            this.selectTitle[2].child = this.domesticCityList;
          }
        });
    },
     // 查询国际长线
    getForeignCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/foreignCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.foreignCityList = res.data.foreignCityList;
            if (this.foreignCityList) {
              this.foreignCityList.forEach((foreignCity) => {
                foreignCity.id = foreignCity.cityId;
                foreignCity.name = foreignCity.cityName;
              });
            }
            console.log();
            this.selectTitle[3].child = this.foreignCityList;
          }
        });
    },
    // 去团建列表页
    toTeamBuilding(id,playTypeId) {
      this.$router.push({
        path: "/teamBuilding",
        query: { playId: id, playTypeId:playTypeId}
      });
    },
    // 获取广告
    getBanner() {
      // const params = {
      //   positionId: 6,
      // };
      axios
        .get(`/api/adm/list`, {
          params:{
             positionId: 6,
             cityId:this.getLocationSiteCityId
          }
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            this.bannerArray = res.data.adList;

            this.bannerArray.forEach((banner) => {
              banner.path = this.handlePic(banner.path);
            });
          }
        });
    },
    // 获取广告
    getProcessBanner() {
      const params = {
        positionId: 18,
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            this.processArray = res.data.adList;
            let index = 0;
            this.processArray.forEach((process) => {
              if(process.path){
                process.path = this.handlePic(process.path);
              }else{
                process.path = this.picPath[index];
              }
              index = index +1;
            });
          }
        });
    },
    handleSlideClick(type, url) {
      console.log(type)
      console.log(url)
      if (type === "1") {
        //不是外链
        this.$router.push({ path: url });
      } else if (type === "0") {
        //是外链
        window.location.href = url;
      } else {

      }
    },
    //
    showSelectContent() {
      console.log("showSelectContent");
      this.isSelectContent = !this.isSelectContent;
      if (this.isSelectContent) {
        this.selectTitleNum = 0;
        this.selectContentArray = this.selectTitle[0].child;
      } else {
      }
    },
    // 点非弹框位置关闭弹框
    closeSelectContent() {
      this.closeContentFunction = (e) => {
        const model = document.querySelector(".component-select");
        if (!model.contains(e.target)) {
          this.isSelectContent = false;
        }
      };
      window.addEventListener("click", this.closeContentFunction);
    },
    closeContentFunction() {},
    // 搜索一级标签选中
    selectTitleMethod(index) {
      this.selectTitleNum = index;
      this.selectContentArray = this.selectTitle[index].child;
    },
    // 搜索二级标签选中
    selectContentMethod(id) {
      // 跳转
      this.$router.push({
        path: `/teamBuilding`,
        query: {
          typeNumber: this.selectTitleNum != 0 ? this.selectTitleNum : -1,
          placeId: id,
        },
      });
    },
  },
  mounted() {
    this.getBanner();
    this.closeSelectContent();

    //查询行政区,省内城市，国内城市，国际长线
    this.getSurroundCityList();
    // this.getScenicSpotsList();
    this.getDomesticCityList();
    this.getForeignCityList();
    this.getRegionList();
    this.getProcessBanner();
    // 获取热门玩法
    this.getPopularPlay();
    // this.$refs.hotTeamProduct.initContent();
    this.hotTeamProductMessage.picPreUrl = this.getPreUrl;
    let left = document.documentElement.clientWidth - 540;
    console.log(left)
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  destroyed() {
    window.removeEventListener("click", this.closeContentFunction);
  },

  created() {},
};
</script>

<style scoped>
.swiper-container {
  background-color: #fff;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100% !important;
}
.headnavS {
  display: none;
}
.navS {
  opacity: 0;
}
.navShow {
  animation: rainbow 0.8s linear;
  /* Safari and Chrome: */
  -webkit-animation: rainbow 0.8s linear;
}
@-moz-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1 {
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
}
.gallery-top .slide-1 a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}
/* .gallery-thumbs .swiper-slide {
  width: 100%;
  height: 50px;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide img {
  width: 80px;
  height: 50px;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
} */
</style>

<style scoped>
.swiper-wrapper {
  position: relative;
  height: 640px;
  background: #000;
}
.swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.search-wrapper {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 100px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
  /* background: rgba(0, 0, 0, 0.38); */
}
.search-title {
  text-align: left;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  display: flex;
}
.search-top-wrapper {
  display: flex;
}
.title-item {
}
.search-keyword {
  display: flex;
  justify-content: flex-start;
  margin: 0 auto;
  /*margin-left: 5px;*/
  font-size: 14px;
  font-weight: 500;
}
.keyword-text {
  position: relative;
  text-align: center;
  width: 70px;
  height: 35px;
  line-height: 35px;
  margin-right: 10px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 3px;
}
.keyword-text-active:after {
  content: "";
  width: 0px;
  height: 0px;
  border-top: 8px solid #e24f4f;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  position: absolute;
  top: 35px;
  left: 22px;
}
.swiper-wrapper>>> .swiper-button-prev,.swiper-wrapper>>> .swiper-container-rtl .swiper-button-next{
  left:200px;
  padding: 10px;
}
.swiper-wrapper>>>.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  right: 200px;
  padding: 10px;
}
.keyword-text-active {
  background-color: #e24f4f;
}
.search-input-wrapper {
  display: flex;
  /* background: rgba(0, 0, 0, 0.38); */
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  border: 0;
  border-radius: 4px;
  line-height: 45px;
}
.search-btn {
  background: #359ff8;
  color: #000;
  font-weight: 700;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  /* background: #05a35c; */
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.search-wrapper .home-hots {
  height: 40px;
  font-size: 16px;
  color: #fff;
  line-height: 22px;
  font-weight: 700;
}
.search-wrapper .home-hots span {
  color: #fff;
  float: left;
  margin-right: 10px;
  text-shadow: 0 1px 1px rgb(0 0 0 / 40%);
}
.search-wrapper .home-hots ul {
  display: inline-block;
  list-style: none;
}
.search-wrapper .home-hots ul {
  display: inline-block;
  list-style: none;
}
.search-wrapper .home-hots ul li {
  float: left;
  padding-right: 10px;
  position: relative;
  cursor: pointer;
}
.search-wrapper .home-hots ul li div {
  margin-top: 0;
  height: 22px;
  line-height: 22px;
  background: url(../assets/tag.png) no-repeat;
  background-size: 50px 22px;
  opacity: 0.9;
  border-radius: 2px;
}
.search-wrapper .home-hots ul li div p {
  font-size: 14px;
  font-weight: 700;
  color: #4a4a4a;
  margin-left: 14px;
  height: 100%;
  border-radius: 2px;
  padding-right: 6px;
  background: #fff;
}
.search-wrapper .home-search-bar-content {
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 20%);
  border-radius: 10px;
  flex-direction: row;
  width: 800px;
  flex-wrap: wrap;
  display: flex;
  z-index: 1001;
  position: relative;
}
.component-select {
  width: 100%;
  position: relative;
}
.component-select .component-select-label {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  padding-left: 60px;
  font-weight: 700;
  font-size: 18px;
  color: #404040;
  letter-spacing: 0;
  text-align: left;
  height: 64px;
  line-height: 64px;
}
.component-select .component-select-option {
  font-size: 16px;
  letter-spacing: 0;
  position: relative;
  height: 64px;
  padding: 0 4px;
  margin-left: 144px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all 0.2s ease-in-out;
}
.component-select
  .component-select-option
  .component-select-option-placeholder {
  position: absolute;
  color: #d9d9d9;
  left: 7px;
  height: 64px;
  line-height: 64px;
}
.component-select .component-select-option .component-select-option-drop {
  display: block;
  position: absolute;
  right: 10px;
  top: 0;
  color: #808695;
  transition: all 0.2s ease-in-out;
  height: 64px;
  line-height: 64px;
}
.component-select
  .component-select-option
  .component-select-option-drop
  .el-icon {
  font-size: 24px;
  color: #ccc;
}
.component-select .component-select-label img {
  position: absolute;
  left: 20px;
  top: 20px;
}
.search-wrapper .home-search-bar-content input {
  flex-grow: 1;
  font-size: 16px;
  color: #343434;
  border: none;
  outline: none;
  background: none;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 20px;
}
.search-wrapper .home-search-bar-content input {
  flex-grow: 1;
  font-size: 16px;
  color: #343434;
  border: none;
  outline: none;
  background: none;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 20px;
}
.search-wrapper .home-search-bar-content .home-search-submit {
  background: #359ff8;
  /* box-shadow: 0 4px  6px 0 rgb(255 197 61 / 41%); */
  border-radius: 5px;
  width: 100px;
  height: 48px;
  font-size: 16px;
  color: #fff;
  margin-top: 8px;
  margin-right: 8px;
  line-height: 48px;
  cursor: pointer;
}
.down-arrow {
  color: #47da2a;
}
.up-arrow {
  color: #d64e18;
  transform: rotate(180deg);
}

.component-tabtitle {
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
}

.component-tabtitle .component-tabtitle-item {
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}

/* element.style {
    font-size: 16px;
    color: rgb(34, 34, 34);
} */
.component-tabtitle .component-tabtitle-item .component-tabtitle-name {
  display: inline-block;
  font-size: 16px;
  color: #222;
  vertical-align: middle;
}

element.style {
  width: 760px;
}

.component-select .component-select-content {
  position: absolute;
  width: 99%;
  opacity: 0;
  margin: 5px 0;
  padding: 20px 10px;
  z-index: 1001 !important;
  overflow: auto;
  background: #fff;
  transform: scaleY(0);
  transform-origin: center top 0;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  opacity: 1;
  z-index: 900;
  transform: scaleY(1);
}
.component-select
  .component-select-content
  .component-select-content-items-fold {
  height: 100px;
}

.component-select .component-select-content .component-select-content-items {
  margin: 10px;
  overflow: hidden;
}

.component-select .component-select-content .component-select-content-items ul {
  list-style: none;
  text-align: left;
}
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li {
  cursor: pointer;
  padding: 0 12px;
  margin: 0 4px 4px 0;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  font-size: 14px;
  color: #4a4a4a;
  border-radius: 15px;
}
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li:active,
.component-select
  .component-select-content
  .component-select-content-items
  ul
  li:hover {
  color: #359ff8 !important;
  font-weight: 700;
}

.component-tabtitle .component-tabtitle-item .component-tabtitle-border {
  background: #359ff8;
  border-radius: 4px 4px 0 0;
  width: 60px;
  height: 4px;
  position: absolute;
  left: 50%;
  margin-left: -30px;
  bottom: -10px;
}
.banner-cover {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
  z-index: 1;
}
.home-search-bar-content .customized-tip {
  position: absolute;
  margin: 0px auto ;
  bottom: -56px;
  cursor: pointer;
  /* width: 190px; */
  z-index: 2;
  left: 250px;
}
/* 第一面横幅下方描述 */
@media screen and (min-width: 1060px) {
  .second-part {
    width: 1060px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1060px) {
  .home .home-search-bar,
  .second-part {
    width: 100%;
  }
}
.second-part-out {
  width: 100%;
  background: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.flow {
  height: 80px;
  background: #f7f7f7;
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
  justify-content: center;
}
.flow .flow-item {
  flex: 1;
  position: relative;
}
.flow .flow-item p {
  font-size: 13px;
  color: #666;
  position: absolute;
  left: 70px;
  top: 40px;
  right: 30px;
  line-height: 21px;
  text-align: left;
}
.flow .flow-item span {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  position: absolute;
  left: 70px;
  top: 10px;
}

.flow .flow-item img {
  position: absolute;
  width: 50px;
  height: 50px;
  left: 20px;
  top: 10px;
}
</style>

<style scoped>
/* 放大缩小动画 */
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0% {
    transform: scale(1); /*开始为原始大小*/
  }

  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}
.size-change {
  -webkit-animation-name: scaleDraw; /*关键帧名称*/

  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/

  -webkit-animation-iteration-count: infinite; /*动画播放的次数*/

  -webkit-animation-duration: 5s; /*动画所花费的时间*/
}
</style>




// WEBPACK FOOTER //
// src/components/home.vue